import React from 'react';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import makeStyles from '@mui/styles/makeStyles';
import { TimeSignalSource } from 'graphql/types';

export const DEFAULT_MAX_AVATAR_ITEMS = 3;
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(0.25),
    zIndex: 0,
    justifyContent: 'center'
  },
  avatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    fontSize: theme.typography.fontSize
  }
}));

const useAvatarStyles = makeStyles((theme) => ({
  root: {
    borderWidth: `${theme.spacing(0)} !important`
  },
  img: {
    objectFit: 'unset'
  }
}));

type NoteSourcesProps = {
  sources: TimeSignalSource[];
  maxAvatar?: number;
  className?: string;
};

export const NoteSources: React.FC<NoteSourcesProps> = ({
  sources,
  maxAvatar = DEFAULT_MAX_AVATAR_ITEMS,
  className
}: NoteSourcesProps) => {
  const classes = useStyles();
  const avatarClasses = useAvatarStyles();
  const spacing = sources.length >= maxAvatar ? 'medium' : 0;

  if (sources.length === 0) {
    return null;
  }

  return (
    <AvatarGroup
      max={maxAvatar}
      classes={classes}
      className={className}
      spacing={spacing}
      data-testid={'group-note-sources'}
    >
      {sources.map((source, index) => {
        return (
          source.image && (
            <Avatar
              data-testid={`note-sources-${index}`}
              key={source.id}
              alt={source.name}
              src={source.image?.src}
              variant="square"
              classes={avatarClasses}
            />
          )
        );
      })}
    </AvatarGroup>
  );
};

const useEmptyStyles = makeStyles((theme) => ({
  emptySources: {
    width: theme.spacing(7)
  }
}));

export const NoteSourcesEmptyContainer: React.FC = () => {
  const classes = useEmptyStyles();
  return <div className={classes.emptySources} />;
};
